/* lookbook-slider.js
   Location: assets/lookbook-slider.js
*/

(function () {
  'use strict';

  function initLookbookSlider(slider) {
    const trackWrapper = slider.querySelector('.lookbook__track-wrapper');
    const track = slider.querySelector('.lookbook__track');
    const slides = Array.from(slider.querySelectorAll('.lookbook__slide'));
    const dots = Array.from(slider.querySelectorAll('.lookbook__dot'));
    const prevBtn = slider.querySelector('.lookbook__btn--prev');
    const nextBtn = slider.querySelector('.lookbook__btn--next');
    const wrapper = slider.closest('.lookbook__wrapper');
    const itemsWrapper = wrapper ? wrapper.querySelector('.lookbook__items-wrapper') : null;

    if (!track || slides.length === 0) return;

    let current = 0;
    const total = slides.length;

    function updateSlider() {
      const w = trackWrapper.getBoundingClientRect().width;
      track.style.transform = 'translateX(' + (-current * w) + 'px)';

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', String(i === current));
      });

      if (itemsWrapper) {
        itemsWrapper.querySelectorAll('.lookbook__items').forEach(function (panel) {
          const idx = parseInt(panel.dataset.itemsIndex, 10);
          panel.classList.toggle('is-active', idx === current + 1);
        });
      }

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, total - 1));
      updateSlider();
    }

    // ボタン
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // ドット
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // タッチスワイプ
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // キーボード
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // リサイズ時に再計算
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateSlider();
      }, 100);
    });

    // 初期表示：transitionを切ってからセット
    track.style.transition = 'none';
    updateSlider();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        track.style.transition = '';
      });
    });
  }

  function init() {
    document.querySelectorAll('[id^="LookbookSlider-"]').forEach(function (slider) {
      initLookbookSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var slider = e.target.querySelector('[id^="LookbookSlider-"]');
      if (slider) initLookbookSlider(slider);
    });
  }
})();